module.exports = __webpack_public_path__ + "img/wave-5.cce72b32.svg";